import { render, staticRenderFns } from "./MasterDataManagement.vue?vue&type=template&id=cbbec800"
import script from "./MasterDataManagement.vue?vue&type=script&lang=js"
export * from "./MasterDataManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports